import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { useSelector } from 'react-redux'
import { routes } from '../../../consts'

const ZouraIframe = forwardRef(({ pageDetails }, ref) => {
  const iframeRef = useRef()

  const currentRoute = useSelector(state => state.router.location.pathname)

  let { pageId, token, signature, key, tenantId, uri } = pageDetails || {}

  const jsCodeParams = `${
    routes.PROFILE_ROUTE.PAYMENT_DETAILS === currentRoute ? '..' : '.'
  }/ZuoraCheckout.html?pageId=${pageId}&tenantId=${tenantId}&timestamp=${new Date()}&token=${token}&signature=${signature}&key=${key}&uri=${uri}`

  useImperativeHandle(ref, () => ({
    submit() {
      iframeRef?.current?.contentWindow?.postMessage('submit', '*')
    },
  }))

  return (
    <iframe
      id={`paymentFrame ${pageId}`}
      allowFullScreen={true}
      name="paymentFrame"
      frameBorder="0"
      width={'100%'}
      height={'100%'}
      ref={iframeRef}
      src={jsCodeParams}
      sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups allow-forms "
      title="zoura-payment-screen"
    ></iframe>
  )
})

export default React.memo(ZouraIframe)
